import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#FFA141',
                secondary: '#5DDEAD',
                black: '#2D2A26',
                grayScreen: '#F8F8F8',
                grayText: '#9F9F9F',
                grayTitle: '#53504D',
                error: '#a31915',
                white: '#FFFFFF',
                button_primary_color: '#FFA141',
                tableHeader: '#3BB486'
            },
        },
    }
});
